import { Pagination } from '@zep/ui';
import { StoreItem } from '../../../types';
import S from './ManageAsset.module.scss';
import ManageAssetRow from './ManageAssetRow';
const ManageAssetList = ({
  assets = [],
  lastPageNo,
  nowPageNo,
  handlePageChange
}: ManageAssetListProps) => <div className={S.list_wrapper} data-sentry-component="ManageAssetList" data-sentry-source-file="ManageAssetList.tsx">
    <div className={S.list_content}>
      {assets.map(asset => <ManageAssetRow key={asset.hashId} asset={asset} />)}
    </div>
    <Pagination lastPageNo={lastPageNo} nowPageNo={nowPageNo} onPageChange={handlePageChange} data-sentry-element="Pagination" data-sentry-source-file="ManageAssetList.tsx" />
  </div>;
export default ManageAssetList;
type ManageAssetListProps = {
  assets: StoreItem[];
  lastPageNo: number;
  nowPageNo: number;
  handlePageChange: (page: number) => void;
};